import React, { FC } from 'react'
import { Button as AntdButton } from '@pepper/ui'
import { Plus } from 'react-feather'

import styles from './_.module.css'

interface Props {
  text: string
  disabled?: boolean
  update: () => void
  hideIcon?: boolean
}

const Button: FC<Props> = ({ text, update, hideIcon, disabled = false }) => {
  return (
    <AntdButton
      disabled={disabled}
      onClick={update}
      type="dashed"
      className={styles.centerAlignedButton}
    >
      {text}
      {!hideIcon && <Plus className={styles.addIcon} />}
    </AntdButton>
  )
}

export default Button
